import Backdrop from '@mui/material/Backdrop'
import ModalInternal from './modal-internal'

const MODAL_ROOT = document.getElementById('modal-el')

export default function Modal(props) {
  const { component, onClose, title, draggable, maxWidth, fullWidth } = props

  const modalEl = (
    <Backdrop
      open={true}
      sx={{
        color: '#000D18',
        backgroundColor: draggable ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.5)',
      }}
    >
      <ModalInternal
        onClose={onClose}
        title={title}
        draggable={draggable}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
      >
        {component}
      </ModalInternal>
    </Backdrop>
  )

  return ReactDOM.createPortal(modalEl, MODAL_ROOT)
}

Modal.propTypes = {
  title: PropTypes.string,
  component: PropTypes.node,
  onClose: PropTypes.func,
  draggable: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
}
